"use strict";

import {VutAjax} from './VutAjax.js'

//window.addEventListener('DOMContentLoaded', ()=>VutAjax.openPreloader());

window.addEventListener('unload', ()=>{VutAjax.isUnload=true;});
window.addEventListener('beforeunload', ()=>{VutAjax.isUnload=true;});

{

    let crA = function (selector) {
        let
            MATCH = '(-?[_a-zA-Z]+[_a-zA-Z0-9-]*)',
            REGEX = '^(?:' + MATCH + ')|^#' + MATCH + '|^\\.' + MATCH + '|^\\[' + MATCH + '(?:([*$|~^]?=)(["\'])((?:(?=(\\\\?))\\8.)*?)\\6)?\\]';

        let node, match, className;

        for (node = document.createElement( 'a'), match, className = ''; selector && (match = selector.match(REGEX));) {

            if (match[1]) node = document.createElement(match[1]);
            if (match[2]) node.id = match[2];
            if (match[3]) className += ' ' + match[3];
            if (match[4]) node.setAttribute(match[4], match[7] || '');

            selector = selector.slice(match[0].length);
        }

        if (className) node.className = className.slice(1);

        return node;
    };

    let lastStateLocation = window.location.href.split('#')[0];

    let pushState = window.history.pushState.bind(window.history);
    window.history.pushState = function(...args) {
        pushState(...args);
        lastStateLocation = window.location.href.split('#')[0]
    }

    let replaceState = window.history.replaceState.bind(window.history);
    window.history.replaceState = function(...args) {
        replaceState(...args);
        lastStateLocation = window.location.href.split('#')[0]
    }

    window.addEventListener('popstate', (event)=>{
        if (event.state?.VutAjax?.selector) {
            if (lastStateLocation === event.target.location.href.split('#')[0]) return;
            lastStateLocation = event.target.location.href.split('#')[0];
            let a = crA(event.state?.VutAjax?.selector);
            a.href = event.target.location.href;
            a.dataset.vutajaxOptions='{"drop_old_responses":"true","history":"is_popstate"}';
            VutAjax.click({target:a});
        }
    })


}
